module.exports = __webpack_public_path__ + "img/Top01.d5231026.png";